import React from 'react';
import '../../stylesheets/CustomAlert.css';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const CustomAlert = ({ onConfirm, onCancel }) => {
  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert">
        <button className="custom-alert-close" onClick={onCancel}>×</button>
        <div className='heading'>
          <div className="icon-container">
            <PriorityHighIcon />
          </div>
          <span> Alert!!! </span>
        </div>
        <span className='message'> Are you sure you want to delete this user? </span>
        <button className="custom-alert-button" onClick={onConfirm}>Delete</button>
      </div>
    </div>
  );
};

export default CustomAlert;
